import Vue from 'vue'
import Vuex from 'vuex'
import { UIModule, UIUserFull } from "@/api";

Vue.use(Vuex)

class State {
  public user: UIUserFull | null = null;
  public modules: UIModule | null = null;
  public modulesUpdate = 0;
  public connectionState = "connecting";
}

export default new Vuex.Store({
  state: new State(),
  mutations: {
    updateUser (state, newUser: UIUserFull | null) {
      state.user = newUser;
    },
    updateUserModules (state, newUserModules: UIModule | null) {
      state.modules = newUserModules;
      state.modulesUpdate = state.modulesUpdate + 1;
    },
    updateConnectionState (state, connectionState: string) {
      state.connectionState = connectionState;
    },
  },
  actions: {
  },
  modules: {
  }
})
